<template>
<div class="chapter">
<div class="inner_page">
<p class="noindenta"><a id="fm01"></a><a id="page_vii"><em>I read once that water is a symbol for emotions. And for a while now I’ve thought maybe my mother drowned in both</em>.</a></p><a id="page_vii">
<p class="indent"><em>I watch as the wind whips long blond hair around her face. Whitecaps glimmer in the lights from the pier. She doesn’t flinch as the cold hits her. She’s numb from feeling too much, and she has shut it all out. Her eyes are focused on an invisible horizon, and she walks straight out. The waves slap at her, plastering her gauzy skirt to her legs. She’s in up to her chest, and now, as the water surges, she breathes in sharply, involuntarily, because of the cold</em>.</p>
<p class="indent"><em>Her mind is clear at this moment. Nothing but the purity of the cold and the possibility of total peace. She bends her knees and lets the water hit her chin, takes some of the bitter saltiness into her mouth, then lets it run out, eyes still focused on the beyond. She doesn’t take a breath before going under, but exhales completely and dissolves into the blackness without thinking about anything</em>.</p>
<p class="indent"><em>Not even me</em>.</p>
</a><p class="indent"><a id="page_vii"></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?1c2d7bd2